import type {PropsWithChildren} from 'react';
import styles from './company-name.module.css';

type Props = PropsWithChildren<{
  readonly companyName: string;
  readonly companyId: number;
}>;

export function PressReleaseHeaderCompanyName({companyName, companyId}: Props) {
  return (
    <a
      href={`/main/html/searchrlp/company_id/${companyId}`}
      className={styles.companyName}
    >
      {companyName}
    </a>
  );
}
